"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "app-container"
  }, [_c("div", {
    staticStyle: {
      "margin-bottom": "20px",
      display: "flex",
      gap: "10px",
      "align-items": "center"
    }
  }, [_c("el-button", {
    attrs: {
      type: "primary",
      icon: "el-icon-plus"
    },
    on: {
      click: _vm.openAccountDialog
    }
  }, [_vm._v(" Add Email Account ")]), _c("el-button", {
    attrs: {
      type: "success",
      icon: "el-icon-refresh"
    },
    on: {
      click: _vm.openSyncDialog
    }
  }, [_vm._v(" Sync Account ")]), _c("el-select", {
    staticStyle: {
      width: "250px"
    },
    attrs: {
      placeholder: "Select Account",
      clearable: "",
      filterable: ""
    },
    on: {
      change: _vm.handleAccountChange
    },
    model: {
      value: _vm.selectedAccountId,
      callback: function ($$v) {
        _vm.selectedAccountId = $$v;
      },
      expression: "selectedAccountId"
    }
  }, _vm._l(_vm.emailAccounts, function (acc) {
    return _c("el-option", {
      key: acc.id,
      attrs: {
        label: acc.email,
        value: acc.id
      }
    });
  }), 1), _c("el-input", {
    style: {
      width: Math.max(160, (_vm.search ? _vm.search.length * 9 : 0) + 40) + "px",
      marginLeft: "auto"
    },
    attrs: {
      placeholder: "Search emails...",
      "prefix-icon": "el-icon-search",
      clearable: ""
    },
    on: {
      clear: _vm.getList
    },
    nativeOn: {
      keyup: function ($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getList.apply(null, arguments);
      }
    },
    model: {
      value: _vm.search,
      callback: function ($$v) {
        _vm.search = $$v;
      },
      expression: "search"
    }
  })], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.listLoading,
      expression: "listLoading"
    }],
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.list,
      border: "",
      fit: "",
      "highlight-current-row": ""
    },
    on: {
      "row-click": _vm.handleRowClick
    }
  }, [_c("el-table-column", {
    attrs: {
      width: "60",
      label: "ID",
      prop: "id"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "From",
      width: "220"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("strong", [_vm._v(_vm._s(scope.row.from))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "Subject"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("router-link", {
          attrs: {
            to: "/email/view/" + scope.row.id
          }
        }, [_c("span", {
          style: {
            fontWeight: scope.row.isRead ? "normal" : "bold"
          }
        }, [!scope.row.isRead ? _c("i", {
          staticClass: "el-icon-message",
          staticStyle: {
            color: "#409eff",
            "margin-right": "5px"
          }
        }) : _vm._e(), _vm._v(" " + _vm._s(scope.row.subject) + " ")])])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "Date",
      width: "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(_vm._f("moment")(scope.row.receivedAt, "DD-MM-YYYY hh:mm a")) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "Status",
      width: "100",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-tag", {
          attrs: {
            type: scope.row.isRead ? "info" : "primary",
            size: "mini"
          }
        }, [_vm._v(" " + _vm._s(scope.row.isRead ? "Read" : "Unread") + " ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "Actions",
      width: "150",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("div", {
          staticClass: "action-btns"
        }, [!scope.row.isRead ? _c("el-tooltip", {
          attrs: {
            content: "Mark as Read",
            placement: "top"
          }
        }, [_c("button", {
          staticClass: "action-btn action-btn--read",
          attrs: {
            disabled: _vm.markingReadId === scope.row.id
          },
          on: {
            click: function ($event) {
              $event.stopPropagation();
              return _vm.handleMarkAsRead(scope.row);
            }
          }
        }, [_c("i", {
          class: _vm.markingReadId === scope.row.id ? "el-icon-loading" : "el-icon-check"
        }), _c("span", [_vm._v("Read")])])]) : _vm._e(), _c("el-tooltip", {
          attrs: {
            content: "Add to Lead",
            placement: "top"
          }
        }, [_c("button", {
          staticClass: "action-btn action-btn--lead",
          on: {
            click: function ($event) {
              $event.stopPropagation();
              return _vm.handleAddToLead(scope.row);
            }
          }
        }, [_c("i", {
          staticClass: "el-icon-user"
        }), _c("span", [_vm._v("Lead")])])])], 1)];
      }
    }])
  })], 1), _c("div", {
    staticStyle: {
      "margin-top": "20px",
      "text-align": "right"
    }
  }, [_c("el-pagination", {
    attrs: {
      "current-page": _vm.page,
      "page-sizes": [20, 50, 100],
      "page-size": _vm.limit,
      total: _vm.total,
      layout: "total, sizes, prev, pager, next"
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handlePageChange
    }
  })], 1), _c("el-dialog", {
    attrs: {
      title: "Add Email Account",
      visible: _vm.accountDialog,
      width: "500px"
    },
    on: {
      "update:visible": function ($event) {
        _vm.accountDialog = $event;
      }
    }
  }, [_c("el-form", {
    attrs: {
      model: _vm.accountForm,
      "label-width": "120px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Email"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.accountForm.email,
      callback: function ($$v) {
        _vm.$set(_vm.accountForm, "email", $$v);
      },
      expression: "accountForm.email"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Active"
    }
  }, [_c("el-switch", {
    model: {
      value: _vm.accountForm.isActive,
      callback: function ($$v) {
        _vm.$set(_vm.accountForm, "isActive", $$v);
      },
      expression: "accountForm.isActive"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Connect Gmail"
    }
  }, [_c("el-button", {
    attrs: {
      type: "success"
    },
    on: {
      click: _vm.connectGmail
    }
  }, [_vm._v(" Connect with Google ")])], 1)], 1), _c("span", {
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    on: {
      click: function ($event) {
        _vm.accountDialog = false;
      }
    }
  }, [_vm._v("Cancel")]), _c("el-button", {
    attrs: {
      type: "primary",
      loading: _vm.savingAccount
    },
    on: {
      click: _vm.saveAccount
    }
  }, [_vm._v(" Save ")])], 1)], 1), _c("el-dialog", {
    attrs: {
      title: "Sync Email Accounts",
      visible: _vm.syncDialog,
      width: "640px"
    },
    on: {
      "update:visible": function ($event) {
        _vm.syncDialog = $event;
      },
      open: _vm.loadAccounts
    }
  }, [_c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loadingAccounts,
      expression: "loadingAccounts"
    }],
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.emailAccounts,
      border: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "Email",
      prop: "email"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "Status",
      width: "100",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-tag", {
          attrs: {
            type: scope.row.isActive ? "success" : "info",
            size: "mini"
          }
        }, [_vm._v(" " + _vm._s(scope.row.isActive ? "Active" : "Inactive") + " ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "Last Synced",
      width: "190"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [scope.row.lastSyncedAt ? _c("span", [_vm._v(" " + _vm._s(_vm._f("moment")(scope.row.lastSyncedAt, "DD-MM-YYYY hh:mm a")) + " ")]) : _c("span", {
          staticStyle: {
            color: "#f56c6c",
            "font-size": "12px"
          }
        }, [_vm._v(" Never synced ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "Action",
      width: "110",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-button", {
          attrs: {
            size: "mini",
            type: "primary",
            icon: "el-icon-refresh",
            loading: _vm.syncingAccountId === scope.row.id,
            disabled: !scope.row.isActive
          },
          on: {
            click: function ($event) {
              return _vm.syncSingleAccount(scope.row);
            }
          }
        }, [_vm._v(" Sync ")])];
      }
    }])
  })], 1), _c("div", {
    staticStyle: {
      "margin-top": "14px",
      "text-align": "right"
    }
  }, [_c("el-button", {
    attrs: {
      type: "success",
      icon: "el-icon-refresh",
      loading: _vm.syncingAll
    },
    on: {
      click: _vm.syncAllAccounts
    }
  }, [_vm._v(" Sync All Active ")])], 1), _c("span", {
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    on: {
      click: function ($event) {
        _vm.syncDialog = false;
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;